import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import cns from 'classnames';
import { isUndefined, isEmpty } from 'lodash';

class RoutingTabs extends Component {
    static propTypes = {
        routeTabs: PropTypes.arrayOf(
            PropTypes.shape({
                path: PropTypes.string.isRequired,
                tabComponent: PropTypes.object,
                tabName: PropTypes.string,
                visible: PropTypes.bool,
                state: PropTypes.object,
                onClick: PropTypes.func
            })
        ).isRequired,
        tabAlignment: PropTypes.oneOf(['left', 'center', 'right', 'mx-auto']),
        className: PropTypes.any
    };

    render() {
        const { routeTabs, tabAlignment = 'right', className = null } = this.props;

        if (routeTabs.length <= 0) {
            return null;
        }

        const tabs = routeTabs.map((routeTabItem) => {
            if (!isUndefined(routeTabItem.visible) && !routeTabItem.visible) {
                return null;
            }

            const toObject = {};
            toObject.pathname = routeTabItem.path;
            if (!isEmpty(routeTabItem.state)) {
                toObject.state = routeTabItem.state;
            }

            return (
                <li key={routeTabItem.path}>
                    <NavLink activeClassName={'activeRoutingTab'} to={toObject} onClick={routeTabItem.onClick}>
                        {routeTabItem.tabName ? routeTabItem.tabName : routeTabItem.tabComponent}
                    </NavLink>
                </li>
            );
        });

        const formattedTabAlignment = tabAlignment.toLocaleUpperCase();
        let alignmentClass = 'centerTabAlignment';
        if (formattedTabAlignment === 'LEFT') {
            alignmentClass = 'leftTabAlignment';
        } else if (formattedTabAlignment === 'CENTER') {
            alignmentClass = 'centerTabAlignment';
        } else if (formattedTabAlignment === 'RIGHT') {
            alignmentClass = 'rightTabAlignment';
        } else if (formattedTabAlignment === 'MX-AUTO') {
            alignmentClass = 'mx-auto';
        }

        return (
            <div className={cns('tabListControl', className)}>
                <ul className={cns('container', 'tabList', alignmentClass)}>{tabs}</ul>
            </div>
        );
    }
}

export default RoutingTabs;
